import MarketCard from './MarketCard'
import { useMarkets } from '../hooks/useMarkets'

const MarketsGrid = ({ limit = 6 }) => {
  const { markets, isLoading } = useMarkets()

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(limit)].map((_, i) => (
          <div key={i} className="card animate-pulse">
            <div className="h-32 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        ))}
      </div>
    )
  }

  const displayMarkets = limit ? markets.slice(0, limit) : markets

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {displayMarkets.map((market) => (
        <MarketCard key={market.id} market={market} />
      ))}
    </div>
  )
}

export default MarketsGrid
